import {
    PROFILE_LOAD,
    PROFILE_LOAD_FAIL,
    PROFILE_LOAD_SUCCESS
} from './constants';

//
export const ProfileLoadReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case PROFILE_LOAD:
            ret.loading = true;
            ret.error = null;
            ret.loadSuccess = null;
            break;
        case PROFILE_LOAD_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.loadDatas = data.loadDatas;
            break;
        case PROFILE_LOAD_FAIL:
            ret.loading = false;
            ret.error = data;
            ret.loadSuccess = false;
            break;
        default:
            return {...state};
    }
    return ret;
}
